/** Party Type refers to if this party is a Person or an Entity */
export enum ePartyTypeData {
  Person = 'PERSON',
  Entity = 'ENTITY',
}

export const DisplayPartyType = {
  [ePartyTypeData.Entity]: 'Entity',
  [ePartyTypeData.Person]: 'Person',
};
